import { createContext, useState, useCallback } from "react";
import { ReportActivityCountResponse } from "../../entities/reports/ReportActivitySummary/ReportActivitySummaryResponse";
import ActivityService from "../../services/ActivityService";

type ICounterMsgContext = {
  inboxCount: ReportActivityCountResponse | undefined;
  getCounterInbox: () => void;
  refreshChats: () => void;
  flagRefreshChats: boolean;
  setFlagRefreshChats: (value: boolean) => void;
};

const defaultCounterMsgContext: ICounterMsgContext = {
  inboxCount: undefined,
  getCounterInbox: () => {},
  refreshChats: () => {},
  flagRefreshChats: false,
  setFlagRefreshChats: () => {}
};

const CounterMsgContext = createContext<ICounterMsgContext>(
  defaultCounterMsgContext
);

const CounterMsgProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [inboxCount, setInboxCount] = useState<ReportActivityCountResponse>();
  const [flagRefreshChats, setFlagRefreshChats] = useState(false);

  const getCounterInbox = useCallback(async () => {
    try {
      const result = await ActivityService.getUnreadCount();
      if (result instanceof Error) {
        return;
      }
      setInboxCount(result);
    } catch (error) {
      return;
    }
  }, []);

  const refreshChats = useCallback(async () => {
    try {
      setFlagRefreshChats(true);
    } catch (error) {
      return;
    }
  }, []);

  const value = {
    inboxCount,
    getCounterInbox,
    refreshChats,
    flagRefreshChats,
    setFlagRefreshChats
  };

  return (
    <CounterMsgContext.Provider value={value}>
      {children}
    </CounterMsgContext.Provider>
  );
};

export { CounterMsgProvider };
export default CounterMsgContext;
